import { render, staticRenderFns } from "./AwaitingList.vue?vue&type=template&id=03a49b98&scoped=true"
import script from "./AwaitingList.vue?vue&type=script&lang=js"
export * from "./AwaitingList.vue?vue&type=script&lang=js"
import style0 from "./AwaitingList.vue?vue&type=style&index=0&id=03a49b98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a49b98",
  null
  
)

export default component.exports